import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons/faCircleExclamation'
import { FormattedMessage } from 'react-intl'
import styles from '../UploadConfigModal.module.scss'

export const UploadConfigDisclaimer = () => {
    return (
        <div className={`mb-4 p-3 d-flex gap-2 ${styles.disclaimer}`}>
            <FontAwesomeIcon
                className="mt-1"
                icon={faCircleExclamation}
            />
            <FormattedMessage id="modals.configs.uploadDisclaimer" />
        </div>
    )
}